module.exports = {
          srcSet: __webpack_public_path__ + "public/images/1c094fbe060b2d77eae4656ca5a5a44e-1920.webp"+" 1920w",
          images:[ {path: __webpack_public_path__ + "public/images/1c094fbe060b2d77eae4656ca5a5a44e-1920.webp",width: 1920,height: 687}],
          src: __webpack_public_path__ + "public/images/1c094fbe060b2d77eae4656ca5a5a44e-1920.webp",
          toString:function(){return __webpack_public_path__ + "public/images/1c094fbe060b2d77eae4656ca5a5a44e-1920.webp"},
          
          width: 1920,
          height: 687
        }